// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"MobileNav_mobileNav__1g19_","close":"MobileNav_close__2WIhi"};